<template>
	<transition-height name="fade">
		<div class="alert alert-warning">
			{{ t.activeSessionCountWarning }}
		</div>
	</transition-height>
</template>

<script setup lang="ts">
import { useStore } from '@/js/stores';
import { computed } from 'vue';

const store = useStore()

// Computeds
const t = computed(() => store.translations)
</script>
